/**
 * D2 — tile-menu entry that appears ONLY when an interval-refresh tile is
 * currently blocked by the read-only scheduled-refresh policy (its query is
 * write-classified). Choosing it asks the tab to confirm granting persisted
 * schedule trust (the confirmation the plan requires); the tab owns the dialog
 * because Radix menu items can't host one. Read-only tiles never see it — they
 * already refresh on schedule.
 */
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { selectTileRuntime, useDashboardRuntimeStore } from '../store/dashboardRuntimeStore';
import type { QueryBackedTile } from '../services/tileExecutionService';

export function ScheduleTrustMenuItem({
  dashboardId,
  tile,
  onRequestTrust,
}: {
  dashboardId: string;
  tile: QueryBackedTile;
  onRequestTrust: () => void;
}) {
  const runtime = useDashboardRuntimeStore(selectTileRuntime(dashboardId, tile.id));
  const scheduledBlocked =
    tile.refresh.mode === 'interval' &&
    runtime?.status === 'stale' &&
    runtime?.staleReason === 'policy-blocked';
  if (!scheduledBlocked) return null;
  return (
    <DropdownMenuItem onClick={onRequestTrust} data-testid="tile-allow-scheduled-item">
      Allow scheduled refresh…
    </DropdownMenuItem>
  );
}
